<template>
  <div>
    <div class="row">
      <!-- sec -->

      <div class="col-12 my-2">
        <section-title title="Mensaje de Bienvenida" has-line />
      </div>
      <div class="col-12 my-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            label="Mensaje de Bienvenida:"
            placeholder="Escribe mensaje de bienvenida"
            v-model="model.welcomeMessage"
            :error="errors[0]"
            custom-error-msg="El campo es requerido"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12 my-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            label="Descripción:"
            placeholder="Escribe una descripción:"
            v-model="model.description"
            :maxlength="3000"
            :error="errors[0]"
            custom-error-msg="El campo es requerido"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12 my-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            label="Subtítulo:"
            placeholder="Subtítulo de sección"
            v-model="model.welcomeSubHeader"
            :error="errors[0]"
            custom-error-msg="El campo es requerido"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>

      <!-- sec -->
      <div class="col-12 my-1">
        <section-title title="Mensaje de Finalización" has-line />
      </div>
      <div class="col-12">
        <i class="far fa-exclamation-circle text-muted mr-2"></i>
        <span class="text-muted">
          Este mensaje se mostrará en la última sección al finalizar el
          cuestionario.
        </span>
      </div>
      <div class="col-12 my-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            label="Mensaje de Finalización:"
            placeholder="Escribe un mensaje para al final del cuestionario"
            v-model="model.finalMessage"
            :maxlength="3000"
            :error="errors[0]"
            :disabled="isReadOnly"
            custom-error-msg="El campo es requerido"
          />
        </validation-provider>
      </div>
      <!-- sec -->
      <div class="col-12 my-1">
        <section-title title="Encabezado de Cuestionario" has-line />
      </div>

      <div class="col-12">
        <i class="far fa-exclamation-circle text-muted mr-2"></i>
        <span class="text-muted">
          Este mensaje se mostrará al inicio del cuestionario.
        </span>
      </div>
      <div class="col-12 my-2">
        <validation-provider ref="title" v-slot="{ errors }" rules="required">
          <custom-input
            label="Título:"
            placeholder="Escribe título"
            v-model="model.headerTitle"
            :error="errors[0]"
            custom-error-msg="El campo es requerido"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>

      <div class="col-12 my-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            label="Subtítulo:"
            placeholder="Subtítulo de sección"
            v-model="model.headerSubTitle"
            :error="errors[0]"
            custom-error-msg="El campo es requerido"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>

      <div class="col-12 my-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            label="Mensaje de Ayuda:"
            placeholder="Escribe un mensaje de ayuda"
            v-model="model.headerHelpMessage"
            :maxlength="3000"
            :error="errors[0]"
            custom-error-msg="El campo es requerido"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';

export default {
  name: 'general-info-tab',
  components: {
    SectionTitle,
    CustomTextArea,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {};
  },
};
</script>
